// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://bvzhphaghrossqcqecsz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ2emhwaGFnaHJvc3NxY3FlY3N6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzMjg3MTYsImV4cCI6MjA4ODkwNDcxNn0.5u-Pva2vFn-MeNcU6jwgUr4x3kYdYiZzBiH9bqyXiMc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);